import { render, staticRenderFns } from "./channelGoods.vue?vue&type=template&id=4b2b5ba0&scoped=true"
import script from "./channelGoods.vue?vue&type=script&lang=js"
export * from "./channelGoods.vue?vue&type=script&lang=js"
import style0 from "./channelGoods.vue?vue&type=style&index=0&id=4b2b5ba0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2b5ba0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b2b5ba0')) {
      api.createRecord('4b2b5ba0', component.options)
    } else {
      api.reload('4b2b5ba0', component.options)
    }
    module.hot.accept("./channelGoods.vue?vue&type=template&id=4b2b5ba0&scoped=true", function () {
      api.rerender('4b2b5ba0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/dangao/brandlist/channelGoods.vue"
export default component.exports